import {Injectable} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {Observable} from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';

/**
 * Móvil y tableta: el mismo corte que la versión móvil del resto de la app (tablas con desplazamiento,
 * indicadores de 150px). Decisión del usuario (2026-11-03): en esas pantallas el cliente solo consulta.
 */
export const CONSULTA_MEDIA_QUERY = '(max-width: 990px)';

/**
 * Pantallas que crean o rehacen trabajos subiendo STL: en modo consulta no se entra (guard) ni se ofrecen
 * en el menú. Se reconocen por el último tramo de la ruta, que es como las enlaza el menú del API
 * (`pedidos/nuevo_pedido`) y como las declara el routing.
 */
export const RUTAS_SOLO_ESCRITORIO = ['nuevo_pedido', 'regenerar_pedido'];

/** Si un enlace del menú (o una URL) lleva a una de las pantallas de `RUTAS_SOLO_ESCRITORIO`. */
export function esRutaSoloEscritorio(enlace: string | null | undefined): boolean {
    const tramos = (enlace || '').split('?')[0].split('/').filter(t => t !== '');
    return tramos.some(t => RUTAS_SOLO_ESCRITORIO.includes(t));
}

/**
 * Modo consulta: en móvil y tableta el cliente ve pedidos, diseños y segmentaciones, pero no los crea ni
 * los modifica, ni sube STL. Solo puede responder a la validación de un diseño (validar, revisar o
 * rechazar), que no sube nada.
 *
 * Las fichas de edición leen `activo` una vez, al abrir, y se quedan con ese modo: girar una tableta con
 * la ficha abierta no la vuelve editable sin el bloqueo de edición que no se pidió al abrirla.
 */
@Injectable({providedIn: 'root'})
export class ModoConsultaService {

    /** Para lo que se repinta al cambiar el ancho (menú, acciones de las tablas). */
    readonly activo$: Observable<boolean>;

    constructor(private readonly _breakpoints: BreakpointObserver) {
        this.activo$ = this._breakpoints.observe(CONSULTA_MEDIA_QUERY).pipe(
            map(estado => estado.matches),
            distinctUntilChanged()
        );
    }

    /** Si ahora mismo la pantalla es de móvil o tableta. */
    get activo(): boolean {
        return this._breakpoints.isMatched(CONSULTA_MEDIA_QUERY);
    }
}
